import React, { useState } from 'react'
import axios from 'axios'
import { useEffect } from 'react'
import SideBar from '../../SideBar'
import { ExcelExport } from '@progress/kendo-react-excel-export'
import { ExcelExportColumn } from '@progress/kendo-react-excel-export'
import 'rsuite/dist/rsuite.min.css'
import Swal from 'sweetalert2'
import HeaderName from '../../HeaderName'
// import DetailDialog from './detailDialog'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { FaFileExport, FaEye, FaVoteYea, FaCheck, FaPlus } from 'react-icons/fa'
import { Badge } from '@nextui-org/react'
import { Link } from 'react-router-dom'
function Stock() {
  const token = localStorage.getItem('token')
  const url = process.env.REACT_APP_APP_URL
  // const url = 'http://localhost:9000/api/'
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  })

  const scroll = {
    height: '600px',
    overflowY: 'scroll',

  }
  const [confirmList, setConfirmList] = useState([])
  const [value, setValue] = useState('')
  const [open, setOpen] = useState(false)

  const [branchID, setBranchID] = useState('')

  const [hideMed, setHideMed] = useState(true)
  const [medUnitLists, setMedUnitLists] = useState([])
  const [branchesLists, setBranchesLists] = useState([])
  const [searchInput, setSearchInput] = useState('')


  //Search
  const [searchLists, setSearchLists] = useState([])
  const [showSearch, setShowSearch] = useState(false)

  //Branch
  const [brancheFilterLists, setBrancheFilterLists] = useState([])
  const [showBranch, setShowBranch] = useState(false)

  //Date
  const [dateFilterLists, setDateFilterLists] = useState([])
  const [showDate, setShowDate] = useState(false)
  const [to, setTo] = useState('')
  const [from, setFrom] = useState('')


  //Excel Export
  const _export1 = React.useRef(null)
  const excelExport1 = () => {
    if (_export1.current !== null) {
      _export1.current.props.data.map(function (element, index) {
        element.code = element.code
        element.date = element.createdAt?.split('T')[0]
        element.status = element.isConfirmed === true ? 'Confirmed' : 'Pending'
      })

      _export1.current.save()
    }
  }


  useEffect(() => {
    const getMedUnitLists = async () => {
      try {
        const res = await api.get('dismiss/items')

        setMedUnitLists(res.data.data)
        console.log(res.data.data, 'ori me list')
      } catch (err) {
        alert(err.message)
      }
    }
    const getReceivedLists = async () => {
      try {
        const res = await api.get('transfer-to-hos')

        // setMedUnitLists(res.data.data)
        setConfirmList(res.data.data)
        // console.log(res.data.data, 'rec list')
      } catch (err) {
        alert(err.message)
      }
    }

    const getBranches = async () => {
      try {
        const res = await api.get('branches')
        setBranchesLists(res.data.list)
      } catch (err) {
        alert(err.message)
      }
    }

    const getConfirmList = async () => {
      try {
        const res = await api.get('transfer-to-hos')
        // setBranchesLists(res.data.list)
        // console.log(res.data.data, 'con')
      } catch (err) {
        alert(err.message)
      }
    }

    getBranches()
    getConfirmList()
    getReceivedLists()
    getMedUnitLists()

  }, [])

  //Search Filter
  const search = event => {
    if (event) {
      setSearchInput(event)
      setSearchLists(
        medUnitLists.filter(
          el => el?.code.toLowerCase().includes(event.toLowerCase())
        )
      )

      setShowSearch(true)
      setHideMed(false)
      setShowDate(false)
    } else {

      setShowSearch(false)
      setHideMed(true)
      setShowDate(false)
    }


  }



  //show detail view
  const handleDetail = val => {
    // console.log(val, 'imgPath')
    setValue(val)
    setOpen(true)
  }

  //confirm action
  const handleConfirm = (data) => {
    // console.log(data, 'data')
    const jsonData = {
      id: data._id,
      relatedBranch: data.relatedBranch._id
    }


    api
      .post("items/issue-to-Ho/confirm", jsonData)
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "Successfully Created",
          icon: "success",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });

      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });


  }

  //Filter Date
  const handleFilterDate = () => {
    setDateFilterLists(
      medUnitLists.filter(
        el => el.createdAt?.split('T')[0] >= from && (el.createdAt?.split('T')[0] <= to || el.createdAt?.split('T')[0] < to)
      )
    )

    setShowDate(true)
    setShowSearch(false)
    setBrancheFilterLists(false)

    setHideMed(false)
  }

  return (
    <div classNameName='App'>
      <div className='wrapper'>
        <HeaderName />
        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className='content-wrapper'>
          {/* <!-- Content Header (Page header) --> */}
          <div className='content-header'>
            <div className='container-fluid'>
              <div className='row mb-2'>
                <div className='col-sm-12'>
                  <ol className='breadcrumb'>
                    <li className='breadcrumb-item active '>
                      Issue From HO
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className='content'>
            <div className='container-fluid'>
              <div className='row d-flex justify-content-between '>
                <div className='col-md-6'>
                  {/* <h4>Medicine Item List</h4> */}
                </div>
                <div className='offset-1 col-md-4 ml-5'>
                  <div
                    className='input-group row ml-5'
                    style={{ marginBottom: '20px' }}
                  >

                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-12'>
                  <div className='card'>
                    <div className='card-header'>
                      <div className='row flex justify-content-between'>

                        <div className='col-5'>
                          <div className='row'>
                            <div className='flex form-group col-5'>

                              <input
                                type='date'
                                name='from'
                                id='from'
                                onChange={e => setFrom(e.target.value)}
                                className='form-control'
                              />
                            </div>
                            <div className='form-group col-5'>

                              <input
                                type='date'
                                name='to'
                                id='to'
                                onChange={e => setTo(e.target.value)}
                                className='form-control'
                              />
                            </div>
                            <div className='form-group col-2'>
                              <button
                                className='btn btn-sm btn-primary'
                                style={{ marginTop: '10px' }}
                                onClick={handleFilterDate}
                              >
                                Search
                              </button>
                            </div>
                          </div>

                        </div>
                        <div className='col-2'>
                          <input
                            type='text'
                            className='form-control rounded '
                            style={{ borderRadius: '17px' }}
                            name='input'
                            onChange={e =>
                              search(e.target.value)
                            }
                            id='search_code'
                            placeholder='Search Items'
                          />
                        </div>

                        <div className='col-2 mt-2'>
                          <button
                            type='button'
                            className='btn btn-sm btn-dark'
                            onClick={excelExport1}
                          >
                            <FaFileExport />
                            &nbsp; Export
                          </button>
                          &nbsp;
                          <Link
                            to='/issue-ho'
                            className='btn btn-sm btn-primary'

                          >
                            <FaPlus />
                            &nbsp; Add
                          </Link>

                        </div>

                      </div>
                    </div>

                    <div className='card-body'>
                      {/* Export data in Excel */}
                      {/* For Procedure Medicine Items */}
                      <ExcelExport data={hideMed && medUnitLists || showSearch && searchLists || showDate && dateFilterLists} ref={_export1}>
                        <ExcelExportColumn
                          field=''
                          title='No'
                          locked={true}
                          width={30}
                        />
                        <ExcelExportColumn
                          field='date'
                          title='Date'
                          headerCellOptions={{
                            textAlign: 'center'
                          }}
                          width={200}
                        />
                        <ExcelExportColumn
                          field='code'
                          title='Code'
                          headerCellOptions={{
                            textAlign: 'center'
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field='relatedBranch.name'
                          title='Branch'
                          headerCellOptions={{
                            textAlign: 'center'
                          }}
                          width={250}
                        />
                        <ExcelExportColumn
                          field='reason'
                          title='Description'
                          headerCellOptions={{
                            textAlign: 'center'
                          }}
                          width={250}
                        />
                        <ExcelExportColumn
                          field='status'
                          title='Status'
                          headerCellOptions={{
                            textAlign: 'center'
                          }}
                          width={250}
                        />

                      </ExcelExport>
                      {/* End        */}





                      {/* Export Data in Excel end */}
                      <div className='row'>
                        <div className='col-md-12'>
                          <div className='' style={{ scroll }}>
                            <table className='table'>



                              <thead
                                className='sticky-top bg-light'
                                style={{
                                  fontSize: '14px',
                                  fontWeight: 'bold'
                                }}
                              >
                                <tr>
                                  <th style={{ fontWeight: '400px' }}>
                                    #
                                  </th>
                                  <th style={{ fontWeight: '400px' }}>
                                    Created Date
                                  </th>
                                  <th style={{ fontWeight: '400px' }}>
                                    Code
                                  </th>
                                  <th>Branch</th>
                                  <th>Description</th>

                                  <th
                                    className='text-center'
                                    style={{ fontWeight: '400px' }}
                                  >
                                    Action
                                  </th>

                                </tr>
                              </thead>
                              <tbody id='table_body'>
                                {showSearch &&
                                  searchLists.map((item, i) => (
                                    <tr>
                                      <td>{++i}</td>
                                      <td>{item.createdAt?.split('T')[0]}</td>
                                      <td>{item?.code}</td>
                                      <td>{item.relatedBranch ? item.relatedBranch.name : 'HO'}</td>

                                      <td>{item?.reason}</td>

                                      <td className='text-center' style={{ width: '140px  ' }}>


                                        <span
                                          onClick={() =>
                                            handleDetail(item)
                                          }
                                          className=' btn btn-sm btn-outline-dark ml-2'

                                        >
                                          <abbr title="Detail"><FaEye /></abbr>
                                        </span>


                                      </td>
                                    </tr>
                                  ))}

                                {hideMed &&
                                  medUnitLists.map((item, i) => (
                                    <tr>
                                      <td>{++i}</td>
                                      <td>{item.createdAt?.split('T')[0]}</td>
                                      <td>{item?.code}</td>
                                      <td>{item.relatedBranch ? item.relatedBranch.name : 'HO'}</td>

                                      <td>{item?.reason}</td>

                                      <td className='text-center' style={{ width: '140px  ' }}>


                                        <Link to={'/issue_detail/' + item._id}

                                          className=' btn btn-sm btn-outline-dark ml-2'

                                        >
                                          <abbr title="Detail"><FaEye /></abbr>
                                        </Link>


                                      </td>
                                    </tr>
                                  ))}

                                {showDate && dateFilterLists.map((item, i) => (
                                  <tr>
                                    <td>{++i}</td>
                                    <td>{item.createdAt?.split('T')[0]}</td>
                                    <td>{item?.code}</td>
                                    <td>{item.relatedBranch ? item.relatedBranch.name : 'HO'}</td>

                                    <td>{item?.reason}</td>

                                    <td className='text-center' style={{ width: '140px  ' }}>


                                      <span
                                        onClick={() =>
                                          handleDetail(item)
                                        }
                                        className=' btn btn-sm btn-outline-dark ml-2'

                                      >
                                        <abbr title="Detail"><FaEye /></abbr>
                                      </span>


                                    </td>
                                  </tr>
                                ))
                                }
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <DetailDialog open={open} close={() => setOpen(false)} data={value} /> */}
            </div>
          </section>
        </div >
      </div >
      {/* <!-- /.content-wrapper --> */}
      < footer className='main-footer' style={{ marginTop: '1rem' }
      }>
        <strong>
          Copyright &copy; 2017-2020
          <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer >

      {/* <!-- Control Sidebar --> */}
      < aside className='control-sidebar control-sidebar-dark' >
        {/* <!-- Control sidebar content goes here --> */}
      </aside >

      {/* <!-- ./wrapper --> */}
    </div >
  )
}
export default Stock
